import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Params } from '@angular/router';

/** One web tool in the box: its chip in the dock, the left side's copy and the headline over it. */
export interface ToolSlide {
  key: string;
  /** the tool's category on the /tools page (Color Tools, Generators, Converters) and its icon, over the name */
  eyebrow: string;
  eyebrowIcon: string;
  chip: string;
  chipLogo?: string;
  icon: string;
  title: string;
  lead: string;
  text: string;
  facts: string[];
  cta: string;
  link: string;
  queryParams?: Params | null;
  accent: string;
  rest: string;
  line: string;
}

/**
 * The home's Web Tools box (owner 2026-10-11): the app boxes' panel (product-showcase.component.scss)
 * with one tool at a time. Left: the tool's name, what it does and the way to the full tool. Right:
 * its headline and the live tool itself, projected by the home (each tool a `.tls-pane`, the shown
 * one `.on`; all of them stay rendered in one stacked cell, so a tool keeps its state and the box its
 * height when the tool changes). The tools as icons in the dock centred under the box, as the themes box's.
 */
@Component( {
  selector: 'app-tools-showcase',
  templateUrl: './tools-showcase.component.html',
  styleUrls: [
    '../product-showcase/product-showcase.component.scss',
    './tools-showcase.component.scss',
  ],
} )
export class ToolsShowcaseComponent {
  @Input() slides: ToolSlide[] = [];
  /** the key of the tool shown */
  @Input() active = '';
  @Output() pick = new EventEmitter<string>();
  /** the full tool's button was clicked (the home logs it for the tools that track it) */
  @Output() cta = new EventEmitter<string>();

  get slide(): ToolSlide | undefined {
    return this.slides.find( s => s.key === this.active ) || this.slides[ 0 ];
  }

  /** the tools in the /tools page's groups, in the order they come, for the dock */
  get groups(): { label: string; items: ToolSlide[] }[] {
    const out: { label: string; items: ToolSlide[] }[] = [];
    for ( const s of this.slides ) {
      const last = out[ out.length - 1 ];
      if ( last && last.label === s.eyebrow ) {
        last.items.push( s );
      } else {
        out.push( { label: s.eyebrow, items: [ s ] } );
      }
    }
    return out;
  }

  trackGroup( _: number, g: { label: string } ): string {
    return g.label;
  }

  trackSlide( _: number, s: ToolSlide ): string {
    return s.key;
  }
}
